function addComment({ userId, metadataId, comment }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/comments`;
  return apiClient.post(route, { userId, metadataId, comment });
}

function updateComment({ userId, commentId, comment }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/comments/${commentId}`;
  return apiClient.patch(route, { userId, comment });
}

function removeComment({ userId, commentId }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/comments/${commentId}`;
  return apiClient.delete(route, { userId });
}

export default {
  addComment,
  updateComment,
  removeComment
};



// WEBPACK FOOTER //
// ./app/api/CommentsApi.js